// Libraries
import { Flex, Text } from '@chakra-ui/react';
import { Fragment } from 'react';
// Types
import { LabelProps } from './Label.types';

/**
 * `Label` component displays a label above its children.
 * It provides a way to describe the content or the purpose of the children elements.
 *
 * @component
 * @param {LabelProps} props - The props to configure the Label component.
 * @param {string} props.label - The text displayed as the label.
 * @param {ReactNode} props.children - The content or the elements that will be displayed below the label.
 *
 * @returns {ReactElement} The rendered Label component.
 */
export const Label = ({ label, children, ...flexProps }: LabelProps) => {
  return label ? (
    <Flex direction='column' gap={1} {...flexProps}>
      <Text color='grey.100' fontSize='s'>
        {label}
      </Text>
      {children}
    </Flex>
  ) : (
    <Fragment>{children}</Fragment>
  );
};
